/*
 * BBco 10.10.2026 – Shipping notice with formatter fallback
 * Based on the new theme version (connectedCallback + KROWN.functions.formatMoney).
 * If KROWN.functions.formatMoney is not available when the cart renders,
 * the built-in _formatMoney from the previous theme version is used instead.
 * Thresholds come from cart-form.liquid in EUR cents (BBco multi-market block)
 * and are converted to the presentment currency with Shopify.currency.rate.
 */
if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      const textEl = this.querySelector('[data-js-free-shipping-text]');
      const sliderEl = this.querySelector('[data-js-free-shipping-slider]');

      const rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;
      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * rate);
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;

      if ( !freeShippingThreshold || isNaN(freeShippingThreshold) ) {
        return;
      }

      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        if ( textEl ) {
          textEl.innerHTML = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._money(Math.abs(freeShippingRemaining)));
        }
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100 / freeShippingThreshold);
      } else {
        if ( textEl ) {
          textEl.innerHTML = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        }
        cartSliderWidth = 100;
      }
      if ( sliderEl ) {
        sliderEl.style.width = `${cartSliderWidth}%`;
      }

    }

    /* BBco: use the theme formatter when available, otherwise the built-in fallback */
    _money(cents) {
      const format = window.KROWN.settings.shop_money_format;
      const isoCode = window.KROWN.settings.iso_code || '';
      if ( window.KROWN.functions && typeof window.KROWN.functions.formatMoney === 'function' ) {
        return window.KROWN.functions.formatMoney(cents, format) + isoCode;
      }
      return this._formatMoney(cents, format);
    }

    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '{{amount}}';
      const isoCode = (window.KROWN && KROWN.settings && KROWN.settings.iso_code) ? KROWN.settings.iso_code : '';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount + isoCode;
      }

      const match = formatString.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';

      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return match ? formatString.replace(placeholderRegex, value) : value;

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}